import { createEnv } from "@t3-oss/env-nextjs";

import { env as modelsEnv } from "@acme/api/models/env";

export const env = createEnv({
  extends: [modelsEnv],
  server: {},
  client: {},
  experimental__runtimeEnv: {},
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
